/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _CompoundSurveyEditionComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { service } from "@ember/service";
import CompoundSurveyCompletedJournalEvent from "compound-survey/models/compound-survey-completed-journal-event";
import ForcBaseComponent from "core/components/forc/abstract/base-component";
import { Changeset } from "ember-changeset";
import lookupValidator from "ember-changeset-validations";
import { validatePresence } from "ember-changeset-validations/validators";
let CompoundSurveyEditionComponent = (_class = (_CompoundSurveyEditionComponent = class CompoundSurveyEditionComponent extends ForcBaseComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "navigation", _descriptor2, this);
    _initializerDefineProperty(this, "session", _descriptor3, this);
    _initializerDefineProperty(this, "flashMessages", _descriptor4, this);
    _initializerDefineProperty(this, "intl", _descriptor5, this);
    _defineProperty(this, "afterCompleted", this.transitionToDashboard);
    _defineProperty(this, "afterCancel", this.transitionToDashboard);
  }
  get questions() {
    return this.args.surveyCompletedJe.surveyRaw;
  }
  get toastMessage() {
    return this.session.patient ? {
      message: "Questionnaire enregistré. Merci !",
      title: "Questionnaire"
    } : {
      message: "Information bien enregistrée. Merci !"
    };
  }
  get validations() {
    const answersValidations = {};
    this.questions.forEach(q => {
      answersValidations[q.id] = validatePresence({
        presence: true,
        description: "La question"
      });
    });
    const validations = CompoundSurveyCompletedJournalEvent.validations(this.intl);
    validations["answers"] = answersValidations;
    return validations;
  }

  /**
   * The changeset encapsulate the answers object map
   */
  get changeset() {
    if (this._changeset) return this._changeset;
    this._changeset = Changeset(this.args.surveyCompletedJe, lookupValidator(this.validations), this.validations);
    return this._changeset;
  }
  get isDirty() {
    return this.changeset.isDirty;
  }
  async isValid() {
    await this.changeset.validate();
    return this.changeset.get("isValid");
  }
  async save() {
    await this.changeset.validate();
    this.changeset.execute();
    this.args.surveyCompletedJe.patient ||= this.patient;
    await this.args.surveyCompletedJe.save();
    this.flashMessages.success(this.toastMessage.message, {
      title: this.toastMessage.title
    });
  }
  transitionToDashboard() {
    this.router.transitionTo(this.navigation.currentPatientRouteName + ".dashboard");
  }
}, _defineProperty(_CompoundSurveyEditionComponent, "fullComponentId", "constant-monitoring/edition-form"), _CompoundSurveyEditionComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "navigation", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CompoundSurveyEditionComponent as default };